import './app';



// WEBPACK FOOTER //
// ./frontend/src/ts/index.ts